// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__J54CP","checkmark":"Checkbox_checkmark__lf+aD"};